import Modal from "../../../../molecules/Modal"
import styles from "./index.module.scss"

const ModalComponent = ({ title, fnCloseModal, children, size, ...oRest }) => {
  return (
    <Modal isOpen={true} size={size} {...oRest}>
      <Modal.Header onClose={fnCloseModal} style={{ padding: "0.5rem" }}>
        <h1 className={styles.titleModal}>{title}</h1>
      </Modal.Header>
      <Modal.Content
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
          padding: "2rem",
          paddingBottom: "1.5rem",
        }}
      >
        {children}
      </Modal.Content>
    </Modal>
  )
}

export default ModalComponent
